import { render, staticRenderFns } from "./trainingrelease.vue?vue&type=template&id=6ad2ae7a&scoped=true"
import script from "./trainingrelease.vue?vue&type=script&lang=js"
export * from "./trainingrelease.vue?vue&type=script&lang=js"
import style0 from "./trainingrelease.vue?vue&type=style&index=0&id=6ad2ae7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad2ae7a",
  null
  
)

export default component.exports